import { dataFetcher } from 'core/services/requestHandler';   

const submitFeedback = async (data = {}, config = {}) => {
  return dataFetcher('feedback/save', data, {method: 'POST', ...config});
};

export { submitFeedback };
